var $=jQuery;
$(document).ready(function () {

  
$(document).on('change', '.select__select', function () {
 
  var $select = $(this);
  var $productItem = $select.closest('.pdp_detail');
  if (!$productItem.length) return;
  var newImage = $(this).find('option:selected').attr('data-image'); 
  if (newImage) $productItem.find('.pdp-img-crspdp').attr('src', newImage);
  var selectedOptions = [];

  $productItem.find('.select__select').each(function () {
    selectedOptions.push($(this).val());
  });

  var variants;
  try { variants = JSON.parse($productItem.attr('data-variants') || '[]'); } catch { return; }
  if (!Array.isArray(variants)) return;

  var matchedVariant = variants.find(function (variant) {
    return variant.options.every(function (opt, index) {
      return opt === selectedOptions[index];
    });
  });

  if (matchedVariant) {
    var $priceContainer = $productItem.find('.price-custom');
    var priceHtml = '';

    if (matchedVariant.compare_at_price > matchedVariant.price) {
     
      priceHtml += '<span class="sale-price">' + formatMoney(matchedVariant.price) + '</span>';
      priceHtml += '<span class="original-price">' + formatMoney(matchedVariant.compare_at_price) + '</span>';
      // priceHtml += '<span class="du-sparst">Du sparst ' + formatMoney(matchedVariant.compare_at_price - matchedVariant.price) + '</span>';
    } else {
      priceHtml += '<span class="regular-price">' + formatMoney(matchedVariant.price) + '</span>';
    }
    // priceHtml = priceHtml.replace("€", ' €')
    $priceContainer.html(priceHtml);

    $productItem.find('.product-variant-id').val(matchedVariant.id);
    var $btn = $productItem.find('button[type="submit"]');
    if (matchedVariant.available) {
      $btn.prop('disabled', false);
    } else {
      $btn.prop('disabled', true);
    }
  }
}); 


  $(document).on('click', '.allgemeine-mobi', function() {
    $(this).next('ul').slideToggle();
    $(this).toggleClass('is-open');
  });
  // add to cart 
    $(document).on('submit', '.js-card-add-to-cart', function(e) {
      e.preventDefault();
      var $form = $(this);
      var formData = new FormData(this);

      var id = formData.get('id');
      
      if (!id) {
        return;
      }

      var $btn = $form.find('[type="submit"]');
      $btn.prop('disabled', true).addClass('loading');

      $.ajax({
        url: '/cart/add.js',
        method: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        dataType: 'json',
        success: function(item) {
            var url = new URL(window.location.href);
              url.searchParams.set("open_cart_n", "2");
              window.location.href = url.toString();
        },
        error: function(xhr, status, error) {
        },
        complete: function() {
          // Re-enable button
          $btn.prop('disabled', false).removeClass('loading');
        }
      });
    });
    // add to cart  


   /*** MINI CART  ***/
   $(document).on("click", ".submit_form", function(e) {
      e.preventDefault(); 
      var $form = $(this).closest("form");
      var $select = $form.find("select[name='id']");
      var $selectedOption = $select.find("option:selected");
      var variantId = $selectedOption.val() || $(this).data("pro-id");
      var minQty = $selectedOption.data("min-qty") || 1;

      $.ajax({
        type: "POST",
        url: window.Shopify.routes.root + "cart/add.js",
        data: JSON.stringify({
          id: variantId,
          quantity: minQty
        }),
        dataType: "json",      
        contentType: "application/json",
        success: function(data) {
          var url = new URL(window.location.href);
          url.searchParams.set("open_cart_n", "2");
          window.location.href = url.toString();
        },
        error: function(xhr, status, error) {
          console.error("Add to cart error:", error);
        }
      });
    });
  /*** MINI CART  ***/ 

 

   $('#verticalTitle').click(function() {
        $(this).toggleClass('active');
        $('.facets__form-vertical,#ProductGridContainer').toggleClass('facets__form-vertical_show');
    });
    $('form#FacetFiltersForm button.button.button--primary').click(function() {
        $('.facets__form-vertical,#ProductGridContainer').toggleClass('facets__form-vertical_show');
    });
    const $select = $('select#SortBy');
    const $container = $('#ProductGridContainer');

    $select.on('mousedown', function() {
        $container.addClass('facets__form-vertical_show');
    });

    $select.on('change blur', function() {
        $container.removeClass('facets__form-vertical_show');
    });
    
    $(document).on('click', '.hero-play', function () {
    var $banner = $(this).closest('.hero-banner');
    var video = $banner.find('video').get(0);

    if (!video) return;

    $banner.addClass('is-playing');
    video.play()?.catch(() => {});
  });


      $('.js-produkte-flickity').flickity({
      imagesLoaded: true,
      cellAlign: 'left',
      contain: true,
      wrapAround: false,
      prevNextButtons: true,
       pageDots: false,
    });


    $('.footer-block.has-dropdown .footer-block__heading').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
    });
    $('.content-bar svg').click(function (e) { 
        e.preventDefault();
        $('.content-bar').slideUp();
    });
    function setEqualHeight() {
      var maxHeight = 0;
      $('.top_product .collection .caption-with-letter-spacing,.top_product .collection .card__heading').css('height', 'auto');
      
      $('.top_product .collection .caption-with-letter-spacing,.top_product .collection .card__heading').each(function() {
          var currentHeight = $(this).outerHeight();
          if (currentHeight > maxHeight) {
              maxHeight = currentHeight;
          }
      });
  
      $('.top_product .collection  .flickity-enabled .caption-with-letter-spacing,.top_product .collection .card__heading').each(function() {
          $(this).css('height', maxHeight + 'px');
      });
    }

    $(document).ready(function() {
        setEqualHeight();
    });
    
    $(window).on('resize', debounce(setEqualHeight, 150));

    //Slider 
    $('.icons_home .icon-text-wrapper,.has_slider .icon-text-wrapper').flickity({ 
        imagesLoaded: true,
        groupCells: false,
        cellAlign: 'left',
        wrapAround: true,
        contain: false,
        prevNextButtons: false,
        pageDots: false,
        autoPlay: 3000,
        percentPosition: false,
        setGallerySize: true
    });
    $('.wrap-gallery-collection').flickity({ 
        imagesLoaded: true,
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'center',
        wrapAround: true,
        prevNextButtons: true,
        pageDots: false,
        rightToLeft: false,
        autoPlay: true,
    });
    $(document).on('click', '.gallery-popup-img', function () {
      if (window.innerWidth <= 992) {
        $('.gallery-mobile-popup img').attr('src', $(this).attr('src'));
        $('.gallery-mobile-popup').addClass('active');
        $('body').addClass('gallery-popup-open');
      }
    });
    $(document).on('click', '.gallery-mobile-popup, .gallery-mobile-popup__close', function () {
      $('.gallery-mobile-popup').removeClass('active');
      $('body').removeClass('gallery-popup-open');
    });

    $(document).on('click', '.gallery-mobile-popup img', function (e) {
      e.stopPropagation();
    });


    function initCollectionSlider() {
  $('.has_slider .product-grid').each(function () {
    const $thisSlider = $(this);
    const itemCount = $thisSlider.find('.grid__item').length;
    const isDesktop = window.innerWidth > 990;

    const shouldShowSlider = (isDesktop && itemCount > 4) || !isDesktop;

    if (shouldShowSlider) {
      if (!$thisSlider.hasClass('flickity-enabled')) {
        $thisSlider.flickity({
          cellAlign: 'left',
          wrapAround: true,
          prevNextButtons: true,
          pageDots: false,
          imagesLoaded: true,
        });
      }
    } else {
      if ($thisSlider.hasClass('flickity-enabled')) {
        $thisSlider.flickity('destroy');
      }
      $thisSlider.addClass('slider-disabled');
    }
  });
}

initCollectionSlider();

let resizeTimer;
$(window).on('resize', function () {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {
    initCollectionSlider();
  }, 200);
});


   slider_mobile();  
  function slider_mobile() {
    if($(window).width() <= 949){
       $(".footer_icon .page-width.icon-text-wrapper").flickity({
          pageDots: false,
          prevNextButtons: false,
          cellAlign: 'left',
          freeScroll: true,
          autoPlay: 2500,
          wrapAround: true
      });

      $(".column_home .multicolumn-list ,.nt_weitere_informationen_sec .page-width.icon-text-wrapper").flickity({
          pageDots: false,
          wrapAround: true,
          prevNextButtons: true,
          cellAlign: 'left',
          adaptiveHeight: true
      });

      $(".icons_home .icon-text-wrapper").flickity({
          pageDots: false,
          freeScroll: true,
          wrapAround: true,
          prevNextButtons: false,
          cellAlign: 'center',
      });

      $('.vg-mobile-slider').flickity({
        pageDots: false,       
        prevNextButtons: true, 
        cellAlign: 'left',     
        contain: true,         
        wrapAround: true,        
    });

    }
  } 
  $(window).on('resize', debounce(slider_mobile, 150));
 

// PDP SLIDER 

  var $gallery = $('.product-single__gallery');
    var $thumbList = $('.product-single__thumbnails');
    var $thumbPrev = $('.product__thumb-arrow--prev');
    var $thumbNext = $('.product__thumb-arrow--next');
  
    if (!$gallery.length || !$thumbList.length) return;
  
    // Init Flickity for main gallery
    if ($gallery.find('li').length >= 2) {
      $gallery.flickity({
        imagesLoaded: true,
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'center',
        wrapAround: true,
        prevNextButtons: true,
        percentPosition: true,
        pageDots: false,
        rightToLeft: false,
        autoPlay: false
        // sync removed intentionally (manual sync is safer with hidden thumbs)
      });
    }
  
    /**
     * Get only thumbnails that are not hidden by color filter
     */
    function getVisibleThumbs() {
      return $thumbList.find('li').not('.product-single__thumbnails--hide');
    }
  
    /**
     * Set active thumbnail by visible index
     */
    function setActiveThumbnail(index) {
      var $visible = getVisibleThumbs();
      if (!$visible.length) return;
  
      // Normalize index (loop behavior)
      if (index < 0) index = $visible.length - 1;
      if (index >= $visible.length) index = 0;
  
      $thumbList.find('li').removeClass('active');
  
      var $active = $visible.eq(index);
      if (!$active.length) return;
  
      $active.addClass('active');
      scrollThumbIntoView($active);
    }
  
    /**
     * Keep active thumbnail visible inside scrollable thumbnail list
     */
    function scrollThumbIntoView($item) {
      if (!$item.length || !$thumbList.length) return;
  
      var listEl = $thumbList.get(0);
      if (!listEl) return;
  
      var currentTop = listEl.scrollTop;
      var listHeight = $thumbList.innerHeight();
  
      // Position relative to UL (more stable with nested wrappers)
      var itemTop = $item.position().top + currentTop;
      var itemHeight = $item.outerHeight(true);
      var itemBottom = itemTop + itemHeight;
  
      var visibleTop = currentTop;
      var visibleBottom = currentTop + listHeight;
  
      if (itemTop < visibleTop) {
        $thumbList.stop().animate({ scrollTop: itemTop - 8 }, 180);
      } else if (itemBottom > visibleBottom) {
        $thumbList.stop().animate({ scrollTop: itemBottom - listHeight + 8 }, 180);
      }
    }
  
    /**
     * Select slide by visible thumbnail index
     */
    function selectSlideByVisibleIndex(visibleIndex) {
      var $visible = getVisibleThumbs();
      if (!$visible.length) return;
  
      // Normalize index for smooth looping
      if (visibleIndex < 0) visibleIndex = $visible.length - 1;
      if (visibleIndex >= $visible.length) visibleIndex = 0;
  
      // Trigger gallery slide change
      if ($gallery.data('flickity')) {
        $gallery.flickity('select', visibleIndex);
      }
  
      // Update active thumb immediately (Flickity change event will also sync)
      setActiveThumbnail(visibleIndex);
    }
  
    /**
     * Get current visible active thumbnail index
     * Fallback to 0 if none is active yet
     */
    function getCurrentVisibleActiveIndex() {
      var $visible = getVisibleThumbs();
      if (!$visible.length) return -1;
  
      var $active = $visible.filter('.active').first();
      if (!$active.length) return 0;
  
      return $visible.index($active);
    }
  
    /**
     * Move to next/prev thumbnail like a slider control
     * direction: 'next' | 'prev'
     */
    function stepThumbSlider(direction) {
      var currentIndex = getCurrentVisibleActiveIndex();
      if (currentIndex < 0) return;
  
      var nextIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;
      selectSlideByVisibleIndex(nextIndex);
    }
  
    // Sync thumbnail when Flickity changes slide
    $gallery.on('change.flickity', function (event, index) {
      setActiveThumbnail(index);
    });
  
    // Initial state
    setActiveThumbnail(0);
  
    // Thumbnail click -> select corresponding slide
    $thumbList.on('click', 'li', function () {
      var $li = $(this);
  
      // Ignore hidden thumbnails
      if ($li.hasClass('product-single__thumbnails--hide')) return;
  
      var $visible = getVisibleThumbs();
      var visibleIndex = $visible.index($li);
      if (visibleIndex < 0) return;
  
      selectSlideByVisibleIndex(visibleIndex);
    });
  
    // Custom thumbnail arrow buttons act like slider buttons
    // IMPORTANT: Your UI naming is reversed visually:
    // - prev button should move DOWN (next item)
    // - next button should move UP (previous item)
  
    // "prev" button -> move to next item
   $thumbPrev.on('click', function (e) {
    e.preventDefault();
    stepThumbSlider('prev');
  });

  // "next" button -> move to next item
  $thumbNext.on('click', function (e) {
    e.preventDefault();
    stepThumbSlider('next');
  });
  
    // If thumbnails are filtered dynamically (e.g. color swatches),
    // trigger this custom event after updating hidden/visible classes.
    $(document).on('thumbs:updated', function () {
      setActiveThumbnail(0);
    });

// /PDP SLIDER


    // $(document).ready(initFlickityMobile);
    // $(window).on('resize', initFlickityMobile);
    //End Slider
});




const params = new URLSearchParams(window.location.search);
if (params.get('open_cart_n') === '2') {
   const cartToggle = document.querySelector('#cart-icon-bubble');
    if (cartToggle) {
      cartToggle.click();
  }
  params.delete('open_cart_n');
  history.replaceState({}, '', `${location.pathname}?${params}`);
}

$('.acc-head').on('click', function() {
        if($(this).hasClass('active')) {
            $(this).siblings('.acc-content').slideUp();
            $(this).removeClass('active');
        }
        else {
            $('.acc-content').slideUp();
            $('.acc-head').removeClass('active');
            $(this).siblings('.acc-content').slideToggle();
            $(this).toggleClass('active');
        }
    });

    



